import React from 'react';
import { Alert } from 'reactstrap';
import FormCard from '../forms/FormCard';

const NavGeometrijaBridinajums = ({ title }) => (
  <FormCard title={title}>
    <Alert color="warning">
      <h5>Nav norādīta ģeometrija</h5>
      <p>
        Sateces baseinam ir nepieciešama ģeometrija.
        Lūdzu, norādiet baseina ģeometriju vai izvēlieties pazemes ūdeņu atradnes ģeometriju.
      </p>
    </Alert>
  </FormCard>
);

export default NavGeometrijaBridinajums;
